import {
  IResponsibleCreateParams,
  IResponsibleProps,
  IResponsibleSimpleProps,
  IResponsibleUpdateParams,
} from './types';
import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import { IResponsibleFilterProps } from '../ResponsibleService/types';

const ENDPOINT = 'v1/recognitions/responsible';

export const createResponsibleAsync = async ({
  data,
  imageFile,
}: IResponsibleCreateParams): Promise<IResponsibleProps> => {
  data.imageFile = imageFile;
  return await api
    .post(ENDPOINT, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getResponsibleByIdAsync = async (
  id: string,
): Promise<IResponsibleProps | undefined> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllResponsibleByLicenseAsync = async (
  pagination?: IPaginationParams,
  filter?: IResponsibleFilterProps,
): Promise<IResponsibleSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllResponsibleCountByLicenseAsync = async (
  filter?: IResponsibleFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateResponsibleAsync = async ({
  id,
  data,
  imageFile,
}: IResponsibleUpdateParams): Promise<IResponsibleProps> => {
  data.imageFile = imageFile;
  return await api
    .put(`${ENDPOINT}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteResponsibleAsync = async (id: string): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
